import { RoutesEnum } from '../../../enums/routes.enum';
import { UserRoleEnum } from '../../../enums/user.enums';
import { NavigationBarItems } from './navigation-bar.types';

export const navigationBarItems: NavigationBarItems[] = [
  {
    iconPath: 'assets/icons/house-light.svg',
    label: 'Home',
    routerLink: RoutesEnum.USER_HOME,
    permissions: [UserRoleEnum.USER],
  },
  {
    iconPath: 'assets/icons/scan-light.svg',
    label: 'Check-In',
    routerLink: RoutesEnum.USER_CHECK_IN,
    permissions: [UserRoleEnum.USER],
  },
  {
    iconPath: 'assets/icons/barbell-light.svg',
    label: 'Gewicht',
    routerLink: RoutesEnum.USER_WEIGHT,
    permissions: [UserRoleEnum.USER],
  },
  {
    iconPath: 'assets/icons/user-light.svg',
    label: 'Profil',
    routerLink: RoutesEnum.USER_PROFILE,
    permissions: [UserRoleEnum.USER],
  },
  {
    iconPath: 'assets/icons/calendar-dots-light.svg',
    label: 'Aktivitäten',
    routerLink: RoutesEnum.COACH_ACTIVITY,
    permissions: [UserRoleEnum.COACH],
  },
  {
    iconPath: 'assets/icons/scan-light.svg',
    label: 'Check-In',
    routerLink: RoutesEnum.COACH_CHECK_IN,
    permissions: [UserRoleEnum.COACH],
  },
  {
    iconPath: 'assets/icons/user-light.svg',
    label: 'Profil',
    routerLink: RoutesEnum.COACH_PROFILE,
    permissions: [UserRoleEnum.COACH],
  },
];
